module.exports = __webpack_public_path__ + "img/27_18.882f5a3c.png";